"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.calculateRecommendation = void 0;
var calculateRecommendation = values => {
  var {
    withdrawalAge,
    currentAge,
    retTaxRate,
    preference
  } = values;
  // When the Roth plan is recommended, return the case number associated with those particularly satisfied conditions
  if (withdrawalAge - currentAge > 5 && (retTaxRate === 'higher' && preference === 'now' || retTaxRate === 'higher' && preference === 'later' || retTaxRate === 'lower' && preference === 'now')) {
    return true;
  }
  return false;
};
exports.calculateRecommendation = calculateRecommendation;